<template>
    <div class="az-form-content">
        <v-container fluid grid-list-xl style="margin-bottom: 100px">
            <v-layout wrap align-center>
                <v-flex xs12 sm3 d-flex>
                    <az-text-view label="Nome"
                                        class="comissao-dados-nome"
                                        :text="value.comissaoApuracao.descricao"
                                        v-if="visualizandoDadosGerais"/>
                    <v-text-field
                            v-else
                            v-model="value.comissaoApuracao.descricao"
                            label="Nome"
                            name="Nome"
                            placeholder="Ex. Comissão de Pregão"
                            v-validate="'required'"
                            :error-messages="errors.collect('Nome')"/>
                </v-flex>
                <v-flex xs12 sm3 d-flex>
                    <az-text-view label="Sigla"
                                        class="comissao-dados-sigla"
                                        :text="value.comissaoApuracao.sigla"
                                        v-if="visualizandoDadosGerais"/>
                    <v-text-field
                            v-else
                            v-model="value.comissaoApuracao.sigla"
                            label="Sigla"
                            name="Sigla"
                            placeholder="Ex CP"
                            v-validate="'required'"
                            :error-messages="errors.collect('Sigla')"/>
                </v-flex>
                <v-flex v-if="exibirCamposAdicionais" xs12 sm3 d-flex>
                    <az-text-view label="Tipo da Comissão"
                                  :text="getTexto(opcoesTipoComissao, value.comissaoConfiguracao.tipoComissao)"
                                  v-if="visualizandoDadosGerais"/>
                    <v-autocomplete
                        v-else
                        v-model="value.comissaoConfiguracao.tipoComissao"
                        name="Tipo da Comissão"
                        label="Tipo da Comissão"
                        placeholder="Selecione"
                        item-text="texto"
                        item-value="valor"
                        :items="opcoesTipoComissao"
                        v-validate="'required'"
                        class="select-comissao"
                        :error-messages="errors.collect('Tipo Comissão')"/>
                </v-flex>
                <v-flex v-if="exibirCamposAdicionais" xs12 sm3 d-flex>
                    <az-text-view label="Tipo do Ato de Designação"
                                  :text="getTexto(opcoesTipoAtoDesignacao, value.comissaoConfiguracao.tipoAtoDesignacao)"
                                  v-if="visualizandoDadosGerais"/>
                    <v-autocomplete
                        v-else
                        v-model="value.comissaoConfiguracao.tipoAtoDesignacao"
                        name="Tipo do Ato de Designação"
                        label="Tipo do Ato de Designação"
                        placeholder="Selecione"
                        item-text="texto"
                        item-value="valor"
                        :items="opcoesTipoAtoDesignacao"
                        v-validate="'required'"
                        class="select-comissao"
                        :error-messages="errors.collect('Tipo do Ato de Designação')"/>
                </v-flex>
              <v-flex v-if="exibirCamposAdicionais && value.comissaoConfiguracao.tipoAtoDesignacao === 5" xs12 sm3 d-flex>
                <az-text-view label="Descrição do Ato de Designação"
                              class="comissao-dados-nr-resolucao"
                              :text="value.comissaoConfiguracao.descricaoAtoDesignacao"
                              v-if="visualizandoDadosGerais"/>
                <v-text-field
                    v-else
                    v-model="value.comissaoConfiguracao.descricaoAtoDesignacao"
                    label="Descrição do Ato de Designação"
                    name="Descrição do Ato de Designação"
                    v-validate="'required'"
                    :error-messages="errors.collect('Descrição do Ato de Designação')"/>
              </v-flex>
              <v-flex v-if="exibirCamposAdicionais" xs12 sm3 d-flex>
                <az-text-view label="Nº do Ato de Designação"
                              class="comissao-dados-nr-resolucao"
                              :text="value.comissaoConfiguracao.numAtoDesignacao"
                              v-if="visualizandoDadosGerais"/>
                <v-text-field
                    v-else
                    v-model="value.comissaoConfiguracao.numAtoDesignacao"
                    label="Nº do Ato de Designação"
                    name="Nº do Ato de Designação"
                    placeholder="Ex. 00123"
                    v-validate="'required'"
                    :error-messages="errors.collect('Nº do Ato de Designação')"/>
              </v-flex>
              <v-flex v-if="exibirCamposAdicionais" xs12 sm3 d-flex>
                <az-text-view label="Ano do Ato de Designação"
                              class="comissao-dados-nr-resolucao"
                              :text="value.comissaoConfiguracao.anoAtoDesignacao"
                              v-if="visualizandoDadosGerais"/>
                <v-text-field
                    v-else
                    type="number"
                    v-model="value.comissaoConfiguracao.anoAtoDesignacao"
                    label="Ano do Ato de Designação"
                    name="Ano do Ato de Designação"
                    placeholder="Ex. 2025"
                    v-validate="'required'"
                    :error-messages="errors.collect('Ano do Ato de Designação')"/>
              </v-flex>
              <v-flex v-if="exibirCamposAdicionais" xs12 sm3 d-flex>
                <az-text-view label="Veículo de Publicação do Ato"
                              :text="getTexto(opcoesVeiculoPublicacao, value.comissaoConfiguracao.veiculoPublicacao)"
                              v-if="visualizandoDadosGerais"/>
                <v-autocomplete
                    v-else
                    v-model="value.comissaoConfiguracao.veiculoPublicacao"
                    name="Veículo de Publicação do Ato"
                    label="Veículo de Publicação do Ato"
                    placeholder="Selecione"
                    item-text="texto"
                    item-value="valor"
                    :items="opcoesVeiculoPublicacao"
                    v-validate="'required'"
                    class="select-comissao"
                    :error-messages="errors.collect('Veículo de Publicação do Ato')"/>
              </v-flex>
              <v-flex v-if="exibirCamposAdicionais && value.comissaoConfiguracao.veiculoPublicacao === 6" xs12 sm3 d-flex>
                <az-text-view label="Descrição do Veículo de Publicação do Ato"
                              class="comissao-dados-nr-resolucao"
                              :text="value.comissaoConfiguracao.descricaoVeiculoPublicacao"
                              v-if="visualizandoDadosGerais"/>
                <v-text-field
                    v-else
                    v-model="value.comissaoConfiguracao.descricaoVeiculoPublicacao"
                    label="Descrição do Veículo de Publicação do Ato"
                    name="Descrição do Veículo de Publicação do Ato"
                    v-validate="'required'"
                    :error-messages="errors.collect('Descrição do Veículo de Publicação do Ato')"/>
              </v-flex>
              <v-flex v-if="exibirCamposAdicionais" xs12 sm3 d-flex>
                <az-text-view label="Url da Publicação do Ato"
                              class="comissao-dados-nr-resolucao"
                              :text="value.comissaoConfiguracao.urlPublicacao"
                              v-if="visualizandoDadosGerais"/>
                <v-text-field
                    v-else
                    v-model="value.comissaoConfiguracao.urlPublicacao"
                    label="Url da Publicação do Ato"
                    name="Url da Publicação do Ato"
                    placeholder="Ex.: https://dio.es.gov.br/"
                    v-validate="'required'"
                    :error-messages="errors.collect('Url da Publicação do Ato')"/>
              </v-flex>
              <v-flex v-if="exibirCamposAdicionais" xs12 sm3 d-flex>
                <az-text-view label="Data Início da Vigência"
                              class="comissao-dados-dt-resolucao"
                              :text="value.comissaoConfiguracao.dtInicioVigencia | az-date"
                              v-if="visualizandoDadosGerais"/>
                <az-date
                    v-else
                    label="Data Início da Vigência"
                    name-date="Data Início da Vigência"
                    v-model="value.comissaoConfiguracao.dtInicioVigencia"
                    is-required/>
              </v-flex>
              <v-flex v-if="exibirCamposAdicionais" xs12 sm3 d-flex>
                <az-text-view label="Data Fim da Vigência"
                              class="comissao-dados-dt-resolucao"
                              :text="value.comissaoConfiguracao.dtFimVigencia | az-date"
                              v-if="visualizandoDadosGerais"/>
                <az-date
                    v-else
                    label="Data Fim da Vigência"
                    name-date="Data Fim da Vigência"
                    v-model="value.comissaoConfiguracao.dtFimVigencia"/>
              </v-flex>
                <v-flex xs12 sm3 d-flex>
                    <az-text-view label="Data da Resolução"
                                        class="comissao-dados-dt-resolucao"
                                        :text="value.comissaoConfiguracao.dataResolucao | az-date"
                                        v-if="visualizandoDadosGerais"/>
                    <az-date
                            v-else
                            label="Data da Resolução"
                            name-date="Data da Resolução"
                            v-model="value.comissaoConfiguracao.dataResolucao"
                            is-required/>
                </v-flex>
                <v-flex xs12 sm3 d-flex>
                    <az-text-view label="Data de Publicação"
                                        class="comissao-dados-dt-publicacao"
                                        :text="value.comissaoConfiguracao.dtPublicacao | az-date"
                                        v-if="visualizandoDadosGerais"/>
                    <az-date
                            v-else
                            label="Data de Publicação"
                            name-date="Data de Publicação"
                            v-model="value.comissaoConfiguracao.dtPublicacao"
                            is-required/>
                </v-flex>
              <v-flex xs12 sm3 d-flex>
                      <az-text-view label="Órgão da Comissão"
                                    :text="value.comissaoApuracao.orgao.nome"
                                    v-if="visualizandoDadosGerais"/>
                      <v-autocomplete
                          v-else
                          v-model="value.comissaoApuracao.orgao"
                          name="Órgão"
                          label="Órgão da Comissão"
                          placeholder="Selecione"
                          item-text="nome"
                          return-object
                          :items="orgaosList"
                          :filter="filtroComboAutoCompleteOrgao"
                          v-validate="'required'"
                          class="select-orgao-comissao"
                          :error-messages="errors.collect('Órgão')"/>
              </v-flex>
                <v-flex xs12 sm3 d-flex>
                    <az-text-view label="Nº da Resolução"
                                        class="comissao-dados-nr-resolucao"
                                        :text="value.comissaoConfiguracao.numResolucao"
                                        v-if="visualizandoDadosGerais"/>
                    <v-text-field
                            v-else
                            v-model="value.comissaoConfiguracao.numResolucao"
                            label="Nº da Resolução"
                            name="Nº da Resolução"
                            placeholder="Ex. 00123"
                            v-validate="'required'"
                            :error-messages="errors.collect('Nº da Resolução')"/>
                </v-flex>
                <v-flex xs12 sm3 d-flex>
                    <az-text-view label="Nº do Decreto"
                                        class="comissao-dados-nr-decreto"
                                        :text="value.comissaoConfiguracao.numDecreto"
                                        v-if="visualizandoDadosGerais"/>
                    <v-text-field
                            v-else
                            v-model="value.comissaoConfiguracao.numDecreto"
                            label="Nº do Decreto"
                            name="Nº do Decreto"
                            placeholder="Ex. 00123"
                            v-validate="{rules: {required:true,max:10}}"
                            :error-messages="errors.collect('Nº do Decreto')" max-length="10"/>
                </v-flex>
                <v-flex xs12 sm3 d-flex>
                  <az-text-view label="Situação"
                                class="comissao-dados-situacao"
                                :text="value.comissaoApuracao.situacao == 'ATIVO' ? 'Ativo' : 'Inativo'"
                                v-if="visualizandoDadosGerais"/>

                  <v-select v-else
                            name="Situação" label="Situação" placeholder="Selecione"
                            class="select-situacao-comissao"
                            v-model="value.comissaoApuracao.situacao"
                            :items="opcaoAtivoInativo"
                            item-text="texto" item-value="valor"
                            v-validate="'required'"
                            :error-messages="errors.collect('Situação')"
                  />
                </v-flex>
              <v-flex xs12 sm6 d-flex align-center>
                <az-text-view
                    v-if="visualizandoDadosGerais"
                    label="Notificação por E‑mail"
                    :text="value.comissaoConfiguracao.notificacaoEmail ? 'Sim' : 'Não'"
                />

                <div v-else class="select-notificacao-email-comissao">
                  <label>
                    Deseja utilizar o serviço de notificação por e-mail no sistema, para receber informações de anexos
                    inseridos na aba de Edital?
                  </label>
                  <v-tooltip bottom>
                    <template #activator="{ on, attrs }">
                      <v-icon small v-bind="attrs" v-on="on">mdi-information-outline</v-icon>
                    </template>
                    <span>Você receberá um e‑mail sempre que um anexo for incluído na aba de Edital.</span>
                  </v-tooltip>

                  <v-radio-group
                      v-model="value.comissaoConfiguracao.notificacaoEmail"
                      row
                      v-validate="'required'"
                      :error-messages="errors.collect('Notificação por E‑mail')"
                      name="Notificação por E‑mail"
                      class="radio-group-notificacao-email"
                      mandatory
                      :rules="[v => v !== null && v !== undefined || 'Este campo é obrigatório']"
                  >
                    <v-radio label="Sim" :value="true" class="radio-button-small"/>
                    <v-radio label="Não" :value="false" class="radio-button-small"/>
                  </v-radio-group>
                </div>
              </v-flex>
              <v-flex xs12 sm12 d-flex class="container-select-orgao">
                  <v-tooltip v-if="value.comissaoApuracao.orgao.logradouro" top>
                    <v-chip slot="activator">{{value.comissaoApuracao.orgao.logradouro}}, n°{{value.comissaoApuracao.orgao.numeroLogradouro}}, {{value.comissaoApuracao.orgao.bairro}},
                  {{value.comissaoApuracao.orgao.municipio.descricao}} - {{value.comissaoApuracao.orgao.municipio.uf}}</v-chip>
                Esse campo será utilizado para informar na Ata, o endereço do Órgão onde será realizada a Licitação.
                  </v-tooltip>
              </v-flex>
                <comissao-dados-membros v-if="!inserindo" v-model="value" :editando="editando"/>
            </v-layout>
        </v-container>
    </div>
</template>

<script>
    import ComissaoDadosMembros from './ComissaoDadosMembros'
    import {mapState} from "vuex";

    export default {
        name: 'ComissaoDados',
        inject: ['$validator'],
        components: {ComissaoDadosMembros},
        data() {
          return {
            opcaoAtivoInativo : [
              {texto : "Ativo", valor : "ATIVO"},
              {texto : "Inativo", valor: "INATIVO"}
            ],
            opcoesTipoComissao : [
              {texto : "Credenciamento", valor : 5},
              {texto : "Especial", valor: 2},
              {texto : "Permanente", valor: 1},
              {texto : "Pregão", valor: 3},
              {texto : "Subcomissão Técnica", valor: 4},
              {texto : "Outra", valor: 6},
            ],
            opcoesTipoAtoDesignacao : [
              {texto : "Decreto", valor : 1},
              {texto : "Portaria", valor: 2},
              {texto : "Ofício", valor: 3},
              {texto : "Termo nos Autos", valor: 4},
              {texto : "Outros", valor: 5},
            ],
            opcoesVeiculoPublicacao : [
              {texto : "Afixação em ambiente público", valor : 5},
              {texto : "Diario Oficial", valor: 1},
              {texto : "Jornal de Circulaçao", valor: 2},
              {texto : "Portal da Transparência", valor: 4},
              {texto : "Sítio Eletrônico Oficial", valor: 3},
              {texto : "Outro", valor: 6},
            ],
          }
        },
        props: {
            value: {
                required: true
            },
            editando: {
                type: Boolean,
                default: false
            },
            inserindo: {
                type: Boolean,
                default: false
            },
            orgaosList: {
              type: Array
            }
        },
        computed: {
          ...mapState(['parametros']),

          visualizandoDadosGerais() {
            return !(this.inserindo || this.editando)
          },
          exibirCamposAdicionais() {
            return this.parametros.propriedadesLicitacao.exibirCamposAdicionaisComissao
          }
        },
        methods: {
          filtroComboAutoCompleteOrgao(item, queryText) {
            const nome = item.nome.toLowerCase()
            const searchText = queryText.toLowerCase()
            return nome.indexOf(searchText) > -1
          },
          getTexto(lista, valor) {
            if(valor) {
              return lista.find(item => item.valor === valor).texto
            }
          }
        }
    }
</script>

<style scoped lang="stylus">

.container-select-orgao
  padding 0px !important
  margin 0px !important

.select-comissao, .select-situacao-comissao, .select-orgao-comissao
  margin-top 15px !important

.radio-group-notificacao-email
  .v-input--radio-group__input
    .v-radio
      .v-input--selection-controls__input
        transform scale(0.8) !important
      .v-label
        font-size 8px !important

.radio-button-small
  .v-input--selection-controls__input
    transform scale(0.8) !important
  .v-label
    font-size 8px !important

</style>